import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-purple-700">Privacy Policy</h1>

      <p className="mb-4">Effective Date: August 2, 2025</p>

      <p className="mb-4">
        Welcome to our free AI-powered tools for background removal and text-behind-image design. Your privacy is important to us. This Privacy Policy outlines how we handle information when you use our services.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. No Personal Data Collection</h2>
      <p className="mb-4">
        We do not collect, store, or share any personal data from our users. You are not required to register or provide any personal information to use our tools.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. Uploaded Images</h2>
      <p className="mb-4">
        All images processed through our tools are handled in-memory only for the duration of your session. We do not store, retain, or use your uploaded images for any purpose after processing.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Cookies & Tracking</h2>
      <p className="mb-4">
        We do not use any tracking cookies, advertising pixels, or third-party analytics that collect user-identifiable data. Basic non-identifiable usage statistics may be logged solely for performance monitoring.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Security</h2>
      <p className="mb-4">
        We employ modern best practices to secure our infrastructure. All image processing occurs securely and temporarily.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Children’s Privacy</h2>
      <p className="mb-4">
        Our services are not directed toward children under the age of 13. We do not knowingly collect any data from children.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Third-Party Links</h2>
      <p className="mb-4">
        Our site may link to external websites. We are not responsible for the privacy practices of these third-party services.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy. Any changes will be posted here with the updated effective date.
      </p>

      <p className="mt-6">If you have questions about this policy, contact us via our website.</p>
    </div>
  );
};

export default PrivacyPolicy;